// custom interstate UI components
import CashDownFieldWithDeferment from '../terms/common/CashDownFieldWithDeferment.interstate';
import DefermentSlideOut from './DefermentSlideOut.interstate';
import { useDeferredDownPaymentSlideOut } from './useDeferredDownPaymentSlideOut';

const CashDownWithDeferment = () => {
    const { isSlideOutOpen, toggleSlideOut, slideOutProps } = useDeferredDownPaymentSlideOut();

    return (
        <>
            <CashDownFieldWithDeferment toggleSlideOut={toggleSlideOut} />
            {isSlideOutOpen && <DefermentSlideOut {...slideOutProps} />}
        </>
    );
};

export default CashDownWithDeferment;
